/* eslint-disable no-var */

/**
 * .
 */
export default function InitFacebookSdk(callback?: () => void) {
  if (window.FB) return callback?.();

  window.fbAsyncInit = function () {
    window.FB.init({
      appId: '456882817676569',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v3.1',
    });

    callback?.();
  };

  // load facebook sdk script
  (function (d: any, s: any, id: any) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
}
